var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HorizontalRule } from "@brushfire/ui";
import { PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateCart } from "../../../data/api";
import { getPaymentMethodId } from "../../../data/helpers";
import { setCartData } from "../../../store/Cart/actions";
var StripeWalletButton = function (_a) {
    var stripe = _a.stripe, widgetPaymentRequest = _a.widgetPaymentRequest, setWalletConfirmationPayload = _a.setWalletConfirmationPayload, setErrorMessage = _a.setErrorMessage, eventNumber = _a.eventNumber;
    var _b = __read(useState(null), 2), stripePaymentRequest = _b[0], setStripePaymentRequest = _b[1];
    var dispatch = useDispatch();
    useEffect(function () {
        var _a, _b;
        if (stripe) {
            var pr_1 = stripe.paymentRequest({
                country: widgetPaymentRequest.currency.toUpperCase() === "USD" ? "US" : widgetPaymentRequest.country,
                currency: widgetPaymentRequest.currency.toLowerCase(),
                total: {
                    label: (_b = (_a = widgetPaymentRequest.paymentProfile) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "Total",
                    amount: Math.round(widgetPaymentRequest.total * 100),
                },
                requestPayerName: true,
                requestPayerEmail: true,
                requestPayerPhone: true,
                requestShipping: false,
            });
            // Check the availability of the Payment Request API.
            pr_1.canMakePayment().then(function (result) {
                if (result) {
                    setStripePaymentRequest(pr_1);
                }
            });
            pr_1.on("paymentmethod", function (ev) { return __awaiter(void 0, void 0, void 0, function () {
                var name_1, lastName_1;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    if (window.location.pathname.includes("checkout")) {
                        name_1 = ((_a = ev.payerName) !== null && _a !== void 0 ? _a : "").split(" ");
                        lastName_1 = name_1.pop();
                        getPaymentMethodId((_c = (_b = ev.paymentMethod.card) === null || _b === void 0 ? void 0 : _b.brand) !== null && _c !== void 0 ? _c : "")
                            .then(function (paymentMethodId) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
                            var payload = {
                                firstName: name_1.join(" "),
                                lastName: lastName_1 !== null && lastName_1 !== void 0 ? lastName_1 : "",
                                address: {
                                    street1: (_d = (_c = (_b = (_a = ev.paymentMethod) === null || _a === void 0 ? void 0 : _a.billing_details) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.line1) !== null && _d !== void 0 ? _d : "",
                                    street2: (_h = (_g = (_f = (_e = ev.paymentMethod) === null || _e === void 0 ? void 0 : _e.billing_details) === null || _f === void 0 ? void 0 : _f.address) === null || _g === void 0 ? void 0 : _g.line2) !== null && _h !== void 0 ? _h : "",
                                    city: (_m = (_l = (_k = (_j = ev.paymentMethod) === null || _j === void 0 ? void 0 : _j.billing_details) === null || _k === void 0 ? void 0 : _k.address) === null || _l === void 0 ? void 0 : _l.city) !== null && _m !== void 0 ? _m : "",
                                    region: (_r = (_q = (_p = (_o = ev.paymentMethod) === null || _o === void 0 ? void 0 : _o.billing_details) === null || _p === void 0 ? void 0 : _p.address) === null || _q === void 0 ? void 0 : _q.state) !== null && _r !== void 0 ? _r : "",
                                    postalCode: (_v = (_u = (_t = (_s = ev.paymentMethod) === null || _s === void 0 ? void 0 : _s.billing_details) === null || _t === void 0 ? void 0 : _t.address) === null || _u === void 0 ? void 0 : _u.postal_code) !== null && _v !== void 0 ? _v : "",
                                    country: (_z = (_y = (_x = (_w = ev.paymentMethod) === null || _w === void 0 ? void 0 : _w.billing_details) === null || _x === void 0 ? void 0 : _x.address) === null || _y === void 0 ? void 0 : _y.country) !== null && _z !== void 0 ? _z : "",
                                },
                                phone: (_0 = ev.payerPhone) !== null && _0 !== void 0 ? _0 : "",
                                email: (_1 = ev.payerEmail) !== null && _1 !== void 0 ? _1 : "",
                                tokenInfo: {
                                    paymentMethodId: ev.paymentMethod.id,
                                },
                                paymentMethodId: paymentMethodId,
                            };
                            if (!payload.address.street1) {
                                setErrorMessage("There was no associated billing address with the card you selected. Please visit your Google/Apple Pay account and add a billing address with your card.");
                                ev.complete("fail");
                            }
                            else {
                                ev.complete("success");
                                setWalletConfirmationPayload(payload);
                            }
                        })
                            .catch(function (err) {
                            setErrorMessage(err);
                            ev.complete("fail");
                        });
                    }
                    return [2 /*return*/];
                });
            }); });
            if (widgetPaymentRequest.cartId) {
                pr_1.on("shippingoptionchange", function (ev) {
                    // Perform server-side request to fetch shipping options
                    if (widgetPaymentRequest.cartId) {
                        updateCart(widgetPaymentRequest.cartId, { shippingId: ev.shippingOption.id }, eventNumber).then(function (_a) {
                            var data = _a.data;
                            dispatch(setCartData(data));
                            ev.updateWith({
                                status: "success",
                                total: {
                                    label: "".concat(data.attendeeCount, " Attendee").concat(data.attendeeCount === 1 ? "" : "s"),
                                    amount: Math.round(data.total * 100),
                                },
                            });
                        });
                    }
                });
            }
        }
    }, [stripe, widgetPaymentRequest]);
    if (!stripePaymentRequest) {
        return null;
    }
    return (_jsx(_Fragment, { children: _jsxs(_Fragment, { children: [_jsx(PaymentRequestButtonElement, { options: { paymentRequest: stripePaymentRequest } }), _jsx(HorizontalRule, __assign({ className: "tt-uppercase" }, { children: "Or Enter Card Details" }))] }) }));
};
export default StripeWalletButton;
